import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';
import {BundleModel, CommonPricingSimplifiedModel} from "../../../models/bundle.model";

@Component({
    selector: 'leap-related-bundles-item',
    templateUrl: './related-bundles-item.component.html',
    styleUrls: ['./related-bundles-item.component.less', '../../../styles/tab-content.less'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class RelatedBundlesItemComponent implements OnInit {
    @Input() bundle: BundleModel;
    @Input() currencySignsMap: Map<string, string>;

    licenseList: CommonPricingSimplifiedModel[];
    selectedLicenseType: string;
    licenseNameList: Set<string>;
    termsList: Partial<CommonPricingSimplifiedModel>[];
    selectedLicenseTerms: Partial<CommonPricingSimplifiedModel>;
    selectedLicenseSku: string;
    price: string;

    constructor() {
    }

    ngOnInit() {
        this.licenseList = Object.values(this.bundle.licensePricing || {})
            .filter(value => value && value.length)
            .flat()
            .map(license => ({
                sku: license.sku,
                licenseType: license.licenseType && license.licenseType.configValue && license.licenseType.configValue.slice(0, -8),
                currency: license.currency && license.currency.configKey,
                listPrice: license.listPrice,
                duration: license.duration,
                durationType: license.durationType && license.durationType.configValue,
                repeatDurationType: license.repeatDurationType && license.repeatDurationType.configValue,
            }));

        this.licenseNameList = new Set(this.licenseList.map((license: CommonPricingSimplifiedModel) => license.licenseType));
        this.selectedLicenseType = this.licenseList[0] && this.licenseList[0].licenseType;
        this.selectedLicenseSku = this.licenseList[0] && this.licenseList[0].sku;

        this.termsList = this.getTerms(this.licenseList, this.selectedLicenseType);
        this.selectedLicenseTerms = this.termsList[0];
        this.price = this.getPrice(this.licenseList[0]);
    }

    licenseChanged(licenseType: string): void {
        const selectedLicense = this.licenseList
            .find((license: CommonPricingSimplifiedModel) => license.licenseType === licenseType);

        this.selectedLicenseType = licenseType;
        this.selectedLicenseSku = selectedLicense && selectedLicense.sku;
        this.termsList = this.getTerms(this.licenseList, this.selectedLicenseType);
        this.selectedLicenseTerms = this.termsList[0];
        this.price = this.getPrice(selectedLicense);
    }

    termChanged(terms: Partial<CommonPricingSimplifiedModel>): void {
        const selectedLicense = this.licenseList.find((license: CommonPricingSimplifiedModel) =>
            license.licenseType === this.selectedLicenseType
            && license.duration === terms.duration
            && license.durationType === terms.durationType
            && license.repeatDurationType === terms.repeatDurationType
        );
        this.selectedLicenseSku = selectedLicense && selectedLicense.sku;
        this.price = this.getPrice(selectedLicense);
    }

    private getTerms(licenseList: CommonPricingSimplifiedModel[], selectedLicenseType: string): Partial<CommonPricingSimplifiedModel>[] {
        return licenseList
            .filter((license: CommonPricingSimplifiedModel) => license.licenseType === selectedLicenseType)
            .map((license: CommonPricingSimplifiedModel) => ({
                duration: license.duration,
                durationType: license.durationType,
                repeatDurationType: license.repeatDurationType,
            }));
    }

    private getPrice(license: CommonPricingSimplifiedModel): string {
        if (license) {
            return `${license.currency ? this.currencySignsMap.get(license.currency) || license.currency : ''} ${license.listPrice === 0 ? 0 : license.listPrice || ''}`;
        }
    }
}

